/**
 *  Component for render messages
 */
import React from 'react';
import {  middleEllipsis } from '../../../Library/helper';
import { ACCOUNT_FILE_URL } from '../../../Config/urls';



const FileDisplay = (props) => {
   
    const {file}     = props;

    return(
        <a href={process.env.REACT_APP_SERVER_URL + "/" + ACCOUNT_FILE_URL + "/" + file.accountID + "/" + file.name} className='file-item' target="_blank"> 
            {["jpg","jpeg","png","gif"].includes(file.ico.toLowerCase()) ?
                <img src={process.env.REACT_APP_SERVER_URL + "/" + ACCOUNT_FILE_URL + "/" + file.accountID + "/" + file.name} alt="message-img"/>
                :
                <div className={"icon " + file.ico.toLowerCase()}>{middleEllipsis(file.name,10,10) }</div>
            }     

        </a>
    );

}

export default FileDisplay;